export default "__VITE_ASSET__cc404f5c__"